export interface ComparisonItem {
  dimension: string;
  icon: string;
  traditional: string;
  traditionalDesc: string;
  prefab: string;
  prefabDesc: string;
  winner: "traditional" | "prefab" | "tie";
}

export const comparisonItems: ComparisonItem[] = [
  {
    dimension: "施工工期",
    icon: "ri-time-line",
    traditional: "12–18 個月",
    traditionalDesc: "現場澆置混凝土，需等待養護期，天候影響大",
    prefab: "6–10 個月",
    prefabDesc: "工廠預製 + 現場組裝，不受天候限制",
    winner: "prefab",
  },
  {
    dimension: "結構精度",
    icon: "ri-ruler-2-line",
    traditional: "現場誤差較大",
    traditionalDesc: "人工模板組立、鋼筋綁扎誤差約 ±10mm",
    prefab: "工廠級精度",
    prefabDesc: "CNC 切割與機器人焊接，誤差控制在 ±2mm 內",
    winner: "prefab",
  },
  {
    dimension: "品質穩定度",
    icon: "ri-shield-check-line",
    traditional: "依現場工班水準浮動",
    traditionalDesc: "施工品質受工班經驗、天候、材料供應影響",
    prefab: "工廠標準化控管",
    prefabDesc: "恆溫恆濕工廠環境，每道工站皆有品檢紀錄",
    winner: "prefab",
  },
  {
    dimension: "現場變更追加",
    icon: "ri-file-warning-line",
    traditional: "變更頻繁",
    traditionalDesc: "設計與施工分離，圖面落差導致現場變更多",
    prefab: "前置設計完成 90%",
    prefabDesc: "工廠生產前設計定稿，大幅減少現場變更",
    winner: "prefab",
  },
  {
    dimension: "耐震性能",
    icon: "ri-earthquake-line",
    traditional: "RC 結構",
    traditionalDesc: "韌性較好但自重重，地震力較大",
    prefab: "輕量化鋼構",
    prefabDesc: "重量僅 RC 的 1/3，地震力小，韌性優異",
    winner: "prefab",
  },
  {
    dimension: "節能表現",
    icon: "ri-temp-cold-line",
    traditional: "斷熱較弱",
    traditionalDesc: "RC 導熱快，夏季室內溫度高",
    prefab: "高效斷熱系統",
    prefabDesc: "複合斷熱牆板 + 氣密設計，室內低 5°C 以上",
    winner: "prefab",
  },
  {
    dimension: "碳排放",
    icon: "ri-leaf-line",
    traditional: "較高",
    traditionalDesc: "現場濕作業多，模板浪費與水泥碳排高",
    prefab: "低碳工法",
    prefabDesc: "乾式施工減少 40% 碳排放，可回收鋼材",
    winner: "prefab",
  },
  {
    dimension: "單坪造價",
    icon: "ri-coins-line",
    traditional: "15–25 萬/坪",
    traditionalDesc: "工資上漲、材料波動，總價不易預估",
    prefab: "18–28 萬/坪",
    prefabDesc: "工廠量產降低單位成本，報價更精準透明",
    winner: "tie",
  },
  {
    dimension: "設計彈性",
    icon: "ri-palette-line",
    traditional: "高度自由",
    traditionalDesc: "任何造型、曲線、大跨度皆可實現",
    prefab: "模組化彈性",
    prefabDesc: "模組組合 + 客製化外皮，九成需求可滿足",
    winner: "tie",
  },
  {
    dimension: "後期維護",
    icon: "ri-tools-line",
    traditional: "RC 耐久佳",
    traditionalDesc: "混凝土耐久性高，但管線更新較困難",
    prefab: "鋼構易檢修",
    prefabDesc: "開放骨架結構，管線與設備易於更換維護",
    winner: "tie",
  },
];

export interface AdvantageItem {
  title: string;
  icon: string;
  desc: string;
  points: string[];
}

export const advantageItems: AdvantageItem[] = [
  {
    title: "縮短 50% 施工工期",
    icon: "ri-timer-flash-line",
    desc: "傳統 RC 建築從基礎到封頂平均需 12–18 個月，預製鋼構僅需 6–10 個月。",
    points: [
      "工廠預製與現場基礎同步進行，非序列式等待",
      "現場組裝如樂高，每單元 1–2 天即可完成",
      "最快紀錄：4 個月完成建築結構體",
    ],
  },
  {
    title: "工廠級品質控管",
    icon: "ri-building-4-line",
    desc: "告別「看天施工」與「看工班手藝」的時代。",
    points: [
      "恆溫恆濕工廠環境，不受風雨影響",
      "每道工站皆有品檢紀錄與追蹤碼",
      "CNC 精密切割 + 機器人自動焊接",
    ],
  },
  {
    title: "輕量化耐震結構",
    icon: "ri-shield-flash-line",
    desc: "鋼構重量僅為 RC 的 1/3，地震作用力大幅降低。",
    points: [
      "結構自重輕，地震慣性力小",
      "鋼材韌性優異，延性破壞而非脆性崩塌",
      "通過國家耐震設計規範與風洞測試",
    ],
  },
  {
    title: "高效節能與淨零",
    icon: "ri-sun-cloudy-line",
    desc: "預製牆板內建複合斷熱層，達到被動式節能效果。",
    points: [
      "室內溫度比室外低 5°C 以上（夏季）",
      "氣密等級達到 Q1 等級標準",
      "全年空調用電量降低 30–50%",
    ],
  },
];